import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, MessageCircle, Sparkles } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-16 sm:py-24 relative overflow-hidden bg-violet-700 text-white" data-id="element-80">
      {/* Decorative background */}
      <div className="absolute inset-0 opacity-10" data-id="element-81">
        <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-white via-transparent to-transparent" data-id="element-82" />
      </div>

      <div className="hidden sm:block absolute top-10 left-10 text-violet-300/30 animate-pulse" data-id="element-83">
        <Sparkles size={48} data-id="element-84" />
      </div>
      <div className="hidden sm:block absolute bottom-10 right-10 text-violet-300/30 animate-pulse" style={{
      animationDelay: '1s'
    }} data-id="element-85">
        <Sparkles size={64} data-id="element-86" />
      </div>

      <div className="max-w-4xl mx-auto px-6 sm:px-8 lg:px-8 text-center relative z-10" data-id="element-87">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-serif mb-6 sm:mb-8 leading-tight" data-id="element-88">
          Tu transformación comienza con un paso. <br data-id="element-89" />
          <span className="italic text-violet-200" data-id="element-90">
            Estoy aquí para acompañarte.
          </span>
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 mt-8 sm:mt-10" data-id="element-91">
          <a href="#servicios" className="w-full sm:w-auto px-8 py-3.5 sm:py-4 bg-white text-violet-700 rounded-full font-medium hover:bg-violet-50 transition-all shadow-lg flex items-center justify-center group" data-id="element-92">
            Reserva tu sesión ahora
            <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-93" />
          </a>
          <a href="https://wa.me/34690752576?text=Hola%2C%20he%20visto%20tu%20web%20y%20me%20gustar%C3%ADa%20recibir%20informaci%C3%B3n%20sobre%20tus%20sesiones%20%F0%9F%99%8F" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto px-8 py-3.5 sm:py-4 bg-transparent text-white border border-violet-400 rounded-full font-medium hover:bg-violet-600 transition-all flex items-center justify-center" data-id="element-94">
            <MessageCircle className="mr-2 w-5 h-5" data-id="element-95" />
            Escríbeme por WhatsApp
          </a>
        </motion.div>
      </div>
    </section>;
}